import { render } from "./historiesHomeworks.vue?vue&type=template&id=07d459bb"
import script from "./historiesHomeworks.vue?vue&type=script&lang=js"
export * from "./historiesHomeworks.vue?vue&type=script&lang=js"

import "./historiesHomeworks.vue?vue&type=style&index=0&id=07d459bb&lang=css"

import exportComponent from "E:\\project\\lms-frontend-admin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__